import { Identifier } from "@/apps/shared/catalog/core/domain/Category/Identifier";
import { ProductCount } from "@/apps/shared/catalog/core/domain/Category/ProductCount";
import { Image } from "@/apps/shared/catalog/core/domain/Category/Image";

export class Category {
  private readonly _id: string;
  private readonly _label: string;
  private readonly _identifier: Identifier | null;
  private readonly _childrenDescription: string;
  private readonly _hasChildren: boolean;
  private readonly _image: Image | null = null;
  private readonly _productCount: ProductCount = new ProductCount(0, 0);

  private _root?: Category;
  private _parent?: Category;
  private _children: Category[] = [];

  constructor(
    id: string,
    label: string,
    identifier: Identifier | null,
    childrenDescription: string,
    children: Category[],
    hasChildren = false,
    image: Image | null = null,
    productCount: ProductCount = new ProductCount(0, 0)
  ) {
    this._id = id;
    this._label = label;
    this._identifier = identifier;
    this._childrenDescription = childrenDescription;
    this._children = children;
    this._children.forEach((c) => (c.parent = this));
    this._hasChildren = this._children.length > 0 || hasChildren;
    this._image = image;
    this._productCount = productCount;
  }

  get id(): string {
    return this._id;
  }

  get label(): string {
    return this._label;
  }

  get identifier(): Identifier | null {
    return this._identifier;
  }

  get childrenDescription(): string {
    return this._childrenDescription;
  }

  get parent(): Category | undefined {
    return this._parent;
  }

  set parent(parent: Category | undefined) {
    if (!parent) {
      return;
    }

    this._parent = parent;
  }

  set children(children: Category[] | null) {
    if (!children) {
      return;
    }

    this._children = children;
    this._children.forEach((c) => (c.parent = this));
  }

  get children(): Category[] {
    return this._children;
  }

  get hasChildren(): boolean {
    return this._hasChildren;
  }

  getRoot(): Category {
    if (this._root) {
      return this._root;
    }

    this._root = this.parent ? this.parent.getRoot() : this;

    return this._root;
  }

  get image(): Image | null {
    return this._image;
  }

  get productCount(): ProductCount {
    return this._productCount;
  }
}
